import { HealthInsurerFormData } from '@/types/healthInsurerFormData'

export const initialHealthInsurerForm: HealthInsurerFormData = {
  id: 0,
  insurerCode: '',
  branchCode: '',
  primaryInsurerCode: '',
  name: '',
  postalCode: '',
  postalCode1: '',
  postalCode2: '',
  addressLine1: '',
  addressLine2: '',
  phoneNumber: '',
  faxNumber: '',
  honorificName: '',
  honorific: '',
  insurerDestinationName: '',
  destinationCode: '',
  destinationName: '',
  destinationCodeAcumoxi: '',
  destinationNameAcumoxi: '',
  insuranceTypeCode: '',
  prefectureCode: '',
  startDate: '',
  primaryInsurerCodeAcumoxi: '',
  insurerDestinationNameAcumoxi: '',
  delegatedDestinationCode: '',
  delegatedDestinationName: '',
  isApproved: '0',
  isObsolete: '0',
}
